<fas-services-table class="table-height" scrollHeight="flex"
  [value]="topicsList"
  [rows]="currentRows"
  [columns]="topicColumns"
  [rowsPerPageOptions]="[10, 25, 50, 100]"
  [first]="currentFirst"
  [paginator]="true"
  [showCheckbox]="false"
  [loading]="isLoading"
  (pageChange)="setCurrentPosition($event)"
  [showCurrentPageReport]="true"
  [showFooterPageReport]="false"
  [isOutlineHeadlight]="true"
  [showSearch]="true"
  searchPlaceholder="Szukaj rozdziału..."
  [dropdownFilters]="dropdownFilters"
  (filtersChange)="onFiltersChange($event)"
  [rowClickFunction]="onRowTap">
</fas-services-table>

<app-topic-details
  [(detailsControl)]="detailsControl"
  [topic]="selectedTopic"
  [topicList]="originalTopicsList"
  [topicIndex]="topicIndex"
  (refreshTopics)="refreshTopics()">
</app-topic-details>
